<template>
  <div id="wrapper" class="page" v-if="system_read">
    <nhan-su-side-bar index="1"></nhan-su-side-bar>

    <div id="content-wrapper">
      <div class="container-fluid">
        <!-- <button class="btn btn-info mb-2" @click.prevent="addItem" v-if="hethong_insert">
          <i class="fas fa-plus"></i> Thêm
        </button>-->
        <!-- <b-table
          id="my-table"
          bordered
          head-variant="dark"
          hover
          responsive
          :fields="fields"
          :items="items"
          @sort-changed="sortChanged"
          :no-local-sorting="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          v-if="currentPage != null"
          table-variant="light"
        >-->
        <b-form-input class="mb-2"
                style="flex-grow: 1"
                v-model="query"
                placeholder="Tìm Họ và Tên và Email"
                @keydown.enter.prevent="queryItem"
                >
              </b-form-input>
        <b-table
          id="my-table"
          bordered
          head-variant="dark"
          hover
          responsive
          :fields="fields"
          :items="items"
          @sort-changed="sortChanged"
          :no-local-sorting="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          v-if="currentPage != null"
          table-variant="light"
        >
          <template v-slot:cell(email)="data">
            <b-link href="#" @click.prevent="updateItem(data.item)">{{data.value}}</b-link>
          </template>
          <!-- <template v-slot:thead-top="data">
            <b-tr>
              <b-td variant="primary">
                <b-form-input
                ></b-form-input>
              </b-td>
              <b-td variant="primary"><b-form-input
                ></b-form-input></b-td>
              <b-td variant="primary"><b-form-input
                ></b-form-input></b-td>
              <b-td variant="primary"></b-td>
            </b-tr>
          </template>-->
          <template v-slot:cell(action)="data">
            <!-- <button
              class="btn btn-info mr-2" @click="updateItem(data.item)"  v-if="hethong_update"
            >-->
            <b-link class="mr-4" href="#" @click.prevent="updateItem(data.item)">
              <i class="fas fa-edit mr-2"></i>
            </b-link>
            <!-- <button
              class="btn btn-danger" @click="deleteItem(data)" v-if="hethong_delete"
            >-->
            <!-- <button
              class="btn btn-danger" @click="deleteItem(data)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>-->
          </template>
        </b-table>
        <b-pagination v-if="currentPage != null"
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="perPage"
          @change="paginationChanged"
        ></b-pagination>
      </div>
      <!-- /.container-fluid -->
      <!-- Sticky Footer -->
      <!-- <footer class="sticky-footer">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>Copyright © Your Website 2019</span>
          </div>
        </div>
      </footer>-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NhanSuSideBar from "../components/NhanSu/NhanSuSideBar";
export default {
  name: "Users",
  components: {
    NhanSuSideBar,
  },
  computed: {
    system_read() {
      return this.$store.getters.hasPermission("system_read");
    },
    hethong_insert() {
      return this.$store.getters.hasPermission("hethong_insert");
    },
    hethong_update() {
      return this.$store.getters.hasPermission("hethong_update");
    },
    hethong_delete() {
      return this.$store.getters.hasPermission("hethong_delete");
    },
  },
  data() {
    return {
      fields: [
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "hovaten",
          label: "Họ và tên",
          sortable: true,
        },
        {
          key: "role_name",
          label: "Nhóm",
        },
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: { width: "30px !important" },
        // },
      ],
      items: [],
      currentPage: null,
      totalRow: null,
      perPage: null,
      sortBy: null,
      sortDesc: null,
      query: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get("/api/employeesystem", { params: to.query })
      .then((response) => {
        next((vm) => vm.initData(response.data));
      })
      .catch((err) => {
        next();
      });
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/employeesystem", { params: to.query })
      .then((response) => {
        this.items = response.data.items;
        this.perPage = response.data.perPage;
        this.currentPage = response.data.currentPage;
        this.totalRow = response.data.totalRow;
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(data) {
      this.items = data.items;
      this.perPage = data.perPage;
      this.currentPage = data.currentPage;
      this.sortBy = data.sortBy;
      this.sortDesc = data.sortDesc;
      this.totalRow = data.totalRow;
    },
    addItem() {
      this.$router.push(`/add_account`);
    },
    updateItem(item) {
      this.$router.push(`/account/${item.manhanvien}`);
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/user/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    sortChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.sortBy = ctx.sortBy;
      query.sortDesc = ctx.sortDesc;
      this.$router.push({ query: query });
    },
    paginationChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      this.currentPage = 1;
      query.page = 1;
      this.item = null;
      this.$router.push({ query: query });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
